"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _input = _interopRequireDefault(require("./binders/input"));

var _textarea = _interopRequireDefault(require("./binders/textarea"));

var _select = _interopRequireDefault(require("./binders/select"));

var _progress = _interopRequireDefault(require("./binders/progress"));

var _output = _interopRequireDefault(require("./binders/output"));

// defaultBinders collection by default contains only one function-checker
var _default = [function (node) {
  switch (node.tagName) {
    case 'INPUT':
      return (0, _input["default"])(node.type);

    case 'TEXTAREA':
      return (0, _textarea["default"])();

    case 'SELECT':
      return (0, _select["default"])(node.multiple);

    case 'PROGRESS':
      return (0, _progress["default"])();

    case 'OUTPUT':
      return (0, _output["default"])();

    default:
      return null;
  }
}];
exports["default"] = _default;
//# sourceMappingURL=defaultbinders.js.map